/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PlayArrowRounded from '@material-ui/icons/PlayArrowRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import DoneRoundedIcon from '@material-ui/icons/DoneRounded';
import { Title, Text } from 'components/Text';
import { COLOR } from 'assets/styles/colors';
import {
  Container, StageItem,
  BoxText, BoxIcons,
} from './styles';

// Componente que renderiza todas as etapas
const StepItems = ({ stageItems, idCase }) => (
  <Container>
    {
      stageItems.filter((item, i) => i !== 4).map((item, index) => (
        <Link
          key={item.path}
          to={item.status !== 'disabled' && {
            pathname: item.path,
            state: {
              idCase: idCase && idCase,
              homeOrigin: true,
            },
          }}
          style={{
            cursor: item.status === 'disabled' && 'inherit',
          }}
        >
          <StageItem key={item.title} status={item.status} data-intercom-target={item.dataIntercomTarget}>
            <BoxText status={item.status}>
              <span>{item.status === 'completed' ? (<DoneRoundedIcon style={{ width: '24px', height: '18px', color: COLOR.WHITE_1 }} />) : index + 1}</span>
              <Title secondary>
                {item.title}
              </Title>
              <Text>
                {item.info}
              </Text>
            </BoxText>
            <BoxIcons status={item.status}>
              {item.status === 'disabled' && (
              <LockRoundedIcon style={{ width: '24px', height: '18px', color: COLOR.GREY_3 }} />
              )}
              <PlayArrowRounded style={{ width: '27px', height: '27px', color: item.status === 'disabled' ? COLOR.GREY_3 : COLOR.GREEN_1 }} />
            </BoxIcons>
          </StageItem>
        </Link>
      ))
    }
  </Container>
);

StepItems.propTypes = {
  stageItems: PropTypes.array.isRequired,
  idCase: PropTypes.number,
};

export default StepItems;
